var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
    _c(
      "ul",
      { staticClass: "pagination justify-content-center" },
      [
        _c(
          "li",
          {
            staticClass: "page-item",
            class: { disabled: _vm.CurrentPage === 1 }
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.CurrentPage - 1)
                  }
                }
              },
              [_vm._v("‹ Previous")]
            )
          ]
        ),
        _vm._v(" "),
        _vm.CurrentPage !== 1
          ? [
              _c(
                "li",
                {
                  staticClass: "page-item",
                  class: { active: _vm.CurrentPage === 1 }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "page-link",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changePage(1)
                        }
                      }
                    },
                    [_vm._v("1")]
                  )
                ]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.CurrentPage > 4
          ? _c("li", { staticClass: "page-item disabled" }, [
              _c("span", { staticClass: "page-link" }, [_vm._v("...")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.visiblePages, function(page) {
          return _c(
            "li",
            {
              key: page,
              staticClass: "page-item",
              class: { active: page === _vm.CurrentPage }
            },
            [
              _c(
                "a",
                {
                  staticClass: "page-link",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.changePage(page)
                    }
                  }
                },
                [_vm._v(_vm._s(page))]
              )
            ]
          )
        }),
        _vm._v(" "),
        _vm.CurrentPage < _vm.totalPages - 3
          ? _c("li", { staticClass: "page-item disabled" }, [
              _c("span", { staticClass: "page-link" }, [_vm._v("...")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.CurrentPage !== _vm.totalPages
          ? [
              _c(
                "li",
                {
                  staticClass: "page-item",
                  class: { active: _vm.CurrentPage === _vm.totalPages }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "page-link",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changePage(_vm.totalPages)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.totalPages))]
                  )
                ]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "page-item",
            class: { disabled: _vm.CurrentPage === _vm.totalPages }
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.CurrentPage + 1)
                  }
                }
              },
              [_vm._v("Next ›")]
            )
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a740d12", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a740d12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Pagination.vue
// module id = null
// module chunks = 